<div class="page-header-container">
    <div class="page-title">
        {{'termsAndConditions.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <button class="btn primary-btn" (click)="createNewCookieMessage()">
        <i class="app-icon icon icon-add icon-xl me-2"></i>
        <span>{{'termsAndConditions.addBtn' | translate}}</span>
    </button>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="hasNoData">
    <no-records-placeholder
        [showNoRecordsHeader]="false"
    ></no-records-placeholder>
</div>

<terms-and-conditions-list-view
    *ngIf="(!hasNoData)"
    [cookies]="cookieMessages"
    [props] ="props"
    (deleteCookieEvent)="deleteCookieHandler($event)"
    (editCookieEvent)="editCookieHandler($event)"
    (redirectCookieConsentEvent)="redirectCookieConsent($event)"
></terms-and-conditions-list-view>

